// Formata o prazo de entrega de uma taxa do /cart/shipping_rates.json.
// delivery_days traz o número de dias; delivery_range traz datas (YYYY-MM-DD).
(function () {
  function businessDaysUntil(value) {
    if (typeof value === 'number') return value;
    var parts = String(value).split('-');
    var target = new Date(+parts[0], +parts[1] - 1, +parts[2]);
    if (isNaN(target.getTime())) return null;

    var cursor = new Date();
    cursor.setHours(0, 0, 0, 0);
    var count = 0;
    while (cursor < target) {
      cursor.setDate(cursor.getDate() + 1);
      var weekday = cursor.getDay();
      if (weekday !== 0 && weekday !== 6) count++;
    }
    return count;
  }

  window.tpFormatDelivery = function (rate) {
    if (!rate) return '';
    var days = rate.delivery_days;
    if (!days || days.length !== 2) {
      if (!rate.delivery_range || rate.delivery_range.length !== 2) return '';
      days = rate.delivery_range.map(businessDaysUntil);
    }

    var min = days[0];
    var max = days[1];
    if (min == null || max == null) return '';
    if (min === max) return min + (min === 1 ? ' dia útil' : ' dias úteis');
    return min + '–' + max + ' dias úteis';
  };
})();
